export const COPY_BY_MODO = {
  Aplicar: {
    criterio: 'Aplicação por',
    data: 'Data de aplicação*',
    valor: 'Valor aplicado*',
    operacao: 'compra',
  },
  Resgatar: {
    criterio: 'Resgate por',
    data: 'Data de resgate*',
    valor: 'Valor resgatado*',
    operacao: 'venda',
  },
}
